/**
 * WHERE A CAPTURE SHOWN BY SOL ACTUALLY OPENS. M9 / S09-04.
 *
 * **ONE PLACE, BECAUSE TWO PLACES ALREADY DRIFTED ONCE.** Sol shows Captures in
 * two shapes — a **cited source** under a grounded claim, and a **close match**
 * under a fuzzy result — and both must navigate the same way. When close matches
 * were first built they were not navigable at all, and that went unnoticed
 * because navigation lived inside the component that happened to have it. It now
 * lives here, so "how does a Sol Capture open?" has exactly one answer.
 *
 * **THE PROJECT ID IS THE RECORD'S OWN, NEVER THE ROUTE'S**, and this signature
 * is what enforces it: there is no overload that could read the address bar. Sol
 * broadens — a question asked inside Tampa Condo can surface a Capture in
 * Bayfront Tower — so building the path from the Project on screen would send
 * Brandon to a Capture id RLS refuses under that Project, and he would be told a
 * record he owns is "not available" seconds after Sol showed it to him.
 *
 * The path is the existing Capture Detail route (`src/app/App.tsx`). Nothing new
 * is introduced, and no id in it is ever rendered as text.
 */
export function captureDetailPath(projectId: string, captureId: string): string {
  return `/projects/${projectId}/captures/${captureId}`;
}
